import { loadJson } from "../core/loadjson"
import { StringHelpers } from "../core/stringhelpers";
import { VaxiluskernaCountry } from "../map/vaxiluskernacountry";
export type WorldGeomCountryGeometry = {
    parent?:WorldGeomCountry;
    type:string,
    coordinates:Array<any>
}
export type WorldGeomCountry = {
    parent?:WorldGeomRegion;
    name: string,
    slug?: string;
    path?: string;
    keywords?:string[],
    geometry: WorldGeomCountryGeometry,
    vaxiCountry?:VaxiluskernaCountry
}
export type WorldGeomRegion = {
    parent?:WorldGeomParentRegion;
    name: string,
    slug?: string;
    countries: {[key:string]: WorldGeomCountry}
}
export type WorldGeomParentRegion = {
    name: string,
    slug?: string;
    regions: {[key:string]: WorldGeomRegion}
}
export type WorldGeomCountrySearchInfo = {
    country: WorldGeomCountry,
    alias?: string|null,
    score: number
}
export type WorldGeomCountryAlias = {
    name:string, //ex: Hawaii
    country:string //ex: USA
}

export class WorldGeom {
   
    private static loaded:boolean;
    private static root:{[key:string]: WorldGeomParentRegion};
    public static countries:Array<WorldGeomCountry>;
    public static aliases:Array<WorldGeomCountryAlias>;
    
    //Singapore

    public static async load():Promise<void> {
        WorldGeom.aliases = [
            {name: "Hawaii", country: "USA"},
            {name: "Teneriffa", country: "Spanien"},
            {name: "Gran Canaria", country: "Spanien"},
            {name: "Malaga", country: "Spanien"},
            {name: "Barcelona", country: "Spanien"},
            {name: "Mallorca", country: "Spanien"},
            {name: "Alicante", country: "Spanien"},
            {name: "Paris", country: "Frankrike"},
            {name: "Berlin", country: "Tyskland"},
            {name: "Kreta", country: "Grekland"},
            {name: "London", country: "England"},
            {name: "Sicilien", country: "Italien"},
            {name: "Hongkong", country: "Kina"},
            {name: "Hanoi", country: "Vietnam"},
            {name: "Ho Chi Minh", country: "Vietnam"},
            {name: "Halong Bay", country: "Vietnam"},
            {name: "Bangkok", country: "Thailand"},
            {name: "Phuket", country: "Thailand"},
            {name: "Krabi", country: "Thailand"},
            {name: "Chiang Mai", country: "Thailand"},
            {name: "Bali", country: "Indonesien"},
            {name: "Kuala Lumpur", country: "Malaysia"},
            {name: "Langkawi", country: "Malaysia"},
            {name: "Taj Mahal", country: "Indien"},
            {name: "Bohol", country: "Filippinerna"}
        ];
        return new Promise(async (resolve, reject) => {
            if(WorldGeom.loaded) return resolve();
            try {
                WorldGeom.root = (await loadJson("/static/world.json?rnd="+(Math.round(Math.random()*9999999)))).root;
                WorldGeom.countries = [];
                for(let m in WorldGeom.root) {
                    let pr = WorldGeom.root[m];
                    pr.slug = m;
                    for(let m2 in pr.regions) {
                        let r = pr.regions[m2];
                        r.slug = m2;
                        r.parent = pr;
                        for(let m3 in r.countries) {
                            let c = r.countries[m3];
                            c.slug = m3;
                            c.path = pr.slug+"/"+r.slug+"/"+c.slug;
                            c.parent = r;
                            c.geometry.parent = c;
                            WorldGeom.countries.push(c);
                        }
                    }
                }
                let o:any = {};
                for(let m in WorldGeom.root) {
                    let c:WorldGeomParentRegion = WorldGeom.root[m];
                    o[c.slug] = {
                        regions: {}
                    };
                    for(let m2 in c.regions) {
                        let c2:WorldGeomRegion = c.regions[m2];
                        o[c.slug].regions[c2.slug] = {
                            name: c2.name,
                            content: "Vid resor till " + c2.name + " finns risken att drabbas av sjukdomar och besvär som vanligtvis inte förekommer i Sverige.",
                            diseases: [
                                'chikingunya',
                                'cholera'
                            ],
                            countries: {}
                        };
                        for(let m3 in c2.countries) {
                            o[c.slug].regions[c2.slug].countries[m3] = {
                                name: c2.countries[m3].name,
                                override: false
                            }
                        }
                    }
                }
                console.log(JSON.stringify(o, null, "\t"));
                resolve(); 
            } catch(e) {
                reject(e);
            }
        });
    }

    public static getCountryBySlug(slug:string):WorldGeomCountry {
        for(let m in WorldGeom.countries) {
            let c = WorldGeom.countries[m];
            if(c.slug == slug) {
                return c;
            }
        }
        return null;
    }
    public static getCountryByName(name:string):WorldGeomCountry {
        for(let m in WorldGeom.countries) {
            let c = WorldGeom.countries[m];
            if(c.name == name) {
                return c;
            }
        }
        return null;
    }

    public static search(search: string, maxMatches:number = -1):Array<WorldGeomCountrySearchInfo> {
        let r:Array<WorldGeomCountrySearchInfo> = [];
        
        for(let m in WorldGeom.countries) {
            let c =  WorldGeom.countries[m];
            let score:number = 0;
            score += StringHelpers.search(c.name, search);
            score += StringHelpers.search(c.parent.name, search);
            if(score>0) r.push({
                country: c,
                score: score   
            });
        }
        for(let m in WorldGeom.aliases) {
            let c = WorldGeom.aliases[m];
            let score:number = 0;
            score += StringHelpers.search(c.name, search);
            if(score>0) {
                let country:WorldGeomCountry = WorldGeom.getCountryByName(c.country);
                if(country!=null) {
                    let alreadyAdded:boolean = false;
                    for(let m in r) {
                        if(r[m].country.name==country.name) alreadyAdded = true;
                    }
                    if(!alreadyAdded) {
                        r.push({
                            country: country,
                            alias: c.name,
                            score: score   
                        });
                    }
                }
            }
        }
        r = r.sort((a:WorldGeomCountrySearchInfo, b:WorldGeomCountrySearchInfo) => {
            if(a.score<b.score) return 1;
            if(a.score>b.score) return -1;
            return 0;
        });
        if(maxMatches>0) {
            if(r.length>maxMatches)
                return r.slice(0, maxMatches);
        }
        return r;
    }

    public static hideAll() {
        for(let m in WorldGeom.countries) {
            let c = WorldGeom.countries[m];
            c.vaxiCountry.setHide(true);
        }
    }
    public static showAll() {
        for(let m in WorldGeom.countries) {
            let c = WorldGeom.countries[m];
            c.vaxiCountry.setHide(false);
        }
    }
}